export class LeaveChatRoom {
    public static readonly type = '[MessagingState] Leave chat room';

    constructor(public room: string, public uuid: string) {}
}
